import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import MissionSection from './components/MissionSection';
import AchievementsSection from './components/AchievementsSection';
import CEOMessageSection from './components/CEOMessageSection';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';
import WorksSection from './components/WorksSection';
import CompanyVisionSection from './components/CompanyVisionSection';
import CompanySection from './components/CompanySection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <MissionSection />
      <WorksSection />
      <CEOMessageSection />
      {/* よくあるご質問 */}
      <section id="faq">
        <FAQSection />
      </section>
      <AchievementsSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
